import React from 'react';
import { ColorPicker } from 'antd';

const CustomColorPicker = ({ state, setState }) => {
  const handleColorChange = (value) => {
    const colorHex = value.toHexString();
    // console.log({ value, colorHex })
    setState(colorHex);
  };

  return (
    <ColorPicker
      value={state}
      onChange={handleColorChange}
      showText
      allowClear
    />
  );
};

export default CustomColorPicker;
